import React from "react";
import { EuiFormRow, EuiFieldPassword } from "@elastic/eui";
import _ from "lodash";

function AbstractPasswordConfirmation({
    options,
    errors,
    entityObject = {},
    register,
    passwordValue,
}) {
    return (
        <EuiFormRow
            label={options.label}
            key={options.name}
            fullWidth
            helpText={options.helpText}
            defaultValue={entityObject[options.name]}
            isInvalid={!_.isNil(errors[options.name])}
            error={options.errorMessage}
        >
            <EuiFieldPassword
                fullWidth
                name={options.name}
                defaultValue={entityObject[options.name]}
                inputRef={register({
                    validate: (value) => value.toString() === passwordValue.current.toString(),
                })}
            />
        </EuiFormRow>
    );
}

export default AbstractPasswordConfirmation;
